import { render, staticRenderFns } from "./WikiPageExistanceStateUpdateModal.vue?vue&type=template&id=1820a7a0"
import script from "./WikiPageExistanceStateUpdateModal.vue?vue&type=script&lang=ts"
export * from "./WikiPageExistanceStateUpdateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports